import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

const Navbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const toggleMenu = (): void => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="fixed z-50 py-4 w-full bg-white shadow-md">
      <div className="container px-6 py-4 mx-auto">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <img src="/codeflair-logo.png" alt="Codeflair" className="w-auto h-10" />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden items-center space-x-8 md:flex">
            <Link to="/" className="font-medium text-gray-700 transition-colors duration-300 hover:text-primary-blue">
              Home
            </Link>
            <Link to="/about" className="font-medium text-gray-700 transition-colors duration-300 hover:text-primary-blue">
              About
            </Link>
            <Link to="/services" className="font-medium text-gray-700 transition-colors duration-300 hover:text-primary-blue">
              Services
            </Link>
            <Link to="/contact" className="btn btn-primary">
              Contact Us
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button onClick={toggleMenu} className="text-gray-700 transition-colors duration-300 hover:text-primary-blue">
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="pb-4 mt-4 border-t border-gray-200 md:hidden">
            <div className="flex flex-col pt-4 space-y-4">
              <Link
                to="/"
                className="font-medium text-gray-700 transition-colors duration-300 hover:text-primary-blue"
                onClick={() => setIsOpen(false)}
              >
                Home
              </Link>
              <Link
                to="/about"
                className="font-medium text-gray-700 transition-colors duration-300 hover:text-primary-blue"
                onClick={() => setIsOpen(false)}
              >
                About
              </Link>
              <Link
                to="/services"
                className="font-medium text-gray-700 transition-colors duration-300 hover:text-primary-blue"
                onClick={() => setIsOpen(false)}
              >
                Services
              </Link>
              <Link to="/contact" className="inline-block text-center btn btn-primary" onClick={() => setIsOpen(false)}>
                Contact Us
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
